"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactPortal = require("react-portal");

var _ = require("./..");

var _Layers = require("../Layers");

var _analytics = require("../../../modules/analytics");

var _hooks = require("../../hooks");

var Modal = function Modal(props) {
  var _useClassNames = (0, _hooks.useClassNames)(props),
      className = _useClassNames.className,
      classNames = _useClassNames.classNames,
      restProps = (0, _objectWithoutPropertiesLoose2.default)(_useClassNames, ["className", "classNames"]);

  var name = restProps.name,
      header = restProps.header,
      body = restProps.body,
      footer = restProps.footer,
      nodeSelector = restProps.nodeSelector,
      isOpen = restProps.isOpen,
      closable = restProps.closable,
      onClose = restProps.onClose,
      other = (0, _objectWithoutPropertiesLoose2.default)(restProps, ["name", "header", "body", "footer", "nodeSelector", "isOpen", "closable", "onClose"]);
  var handleKeydown = (0, _react.useCallback)(function (event) {
    if (event.keyCode === 27 && closable) {
      onClose();
    }
  }, [closable, onClose]);
  var handleOverlayClick = (0, _react.useCallback)(function () {
    if (closable) {
      onClose();
    }
  }, [closable, onClose]);
  var Analytics = (0, _analytics.useAnalytics)();
  (0, _react.useEffect)(function () {
    document.addEventListener('keydown', handleKeydown);
    return function () {
      document.removeEventListener('keydown', handleKeydown);
    };
  }, [handleKeydown]);
  (0, _react.useEffect)(function () {
    if (isOpen) {
      document.body.style.overflow = 'hidden';

      if (Analytics.enabled) {
        Analytics.modalview(name);
      }
    } else {
      document.body.style.overflow = null;
    }

    return function () {
      document.body.style.overflow = null;
    };
  }, [Analytics, isOpen, name]);
  return isOpen && /*#__PURE__*/_react.default.createElement(_reactPortal.Portal, {
    node: document && document.querySelector(nodeSelector)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modalWrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modalOverlay",
    onClick: handleOverlayClick
  }), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (classNames() + " " + className).trim()
  }, other), closable && /*#__PURE__*/_react.default.createElement(_.IconButton, {
    className: classNames('close'),
    icon: "fas fa-times",
    variant: "fill",
    color: "white",
    onClick: onClose
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classNames('inner')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classNames('header')
  }, header), /*#__PURE__*/_react.default.createElement("div", {
    className: classNames('body')
  }, body), /*#__PURE__*/_react.default.createElement("div", {
    className: classNames('footer')
  }, footer)))));
};

Modal.propTypes = {
  /** Modal name used for Analytics pourpose. */
  name: _propTypes.default.string,

  /** It describes a standalone entity that is meaningful on its own. It will be used to generate the component className. */
  alias: _propTypes.default.string,

  /** It extends component styles. */
  className: _propTypes.default.string,

  /** The modal header content. */
  header: _propTypes.default.node,

  /** The modal body content. */
  body: _propTypes.default.node,

  /** The modal footer content. */
  footer: _propTypes.default.node,

  /** Node parent selector */
  nodeSelector: _propTypes.default.string,

  /** If _true_, Modal will be visible */
  isOpen: _propTypes.default.bool,

  /** If _true_, Modal can be closed. */
  closable: _propTypes.default.bool,

  /** Callback function fired when Modal is closed */
  onClose: _propTypes.default.func
};
Modal.defaultProps = {
  name: 'Modal',
  alias: 'Modal',
  className: '',
  nodeSelector: "#" + _Layers.modalLayerId,
  isOpen: true,
  closable: true,
  onClose: function onClose() {
    return null;
  }
};
Modal.displayName = 'Modal';
var _default = Modal;
exports.default = _default;